<template>
  <a
    class="preferred-source"
    href="https://www.google.com/preferences/source?q=asoundeffect.com"
    target="_blank"
    rel="noopener noreferrer"
    data-umami-event="preferred_source_click"
    aria-label="Add as preferred source: A Sound Effect on Google (opens Google)"
    @click="onClick">
    <span class="preferred-source__pill">
      <icon-google class="preferred-source__icon" aria-hidden="true" focusable="false" />
      <span class="preferred-source__full">Add as preferred source</span>
      <span class="preferred-source__short">Preferred source</span>
    </span>
  </a>
</template>

<script setup lang="ts">
import { onMounted } from '#imports';
import IconGoogle from '~/assets/icons/IconGoogleColoured.svg';
import { loadPreferredSource, startPreferredSource } from '~/utils/preferredSource';

onMounted(loadPreferredSource);

function onClick(event: MouseEvent) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (startPreferredSource()) event.preventDefault();
}
</script>

<style scoped lang="scss">
@use "~/common/scss/helpers";
@use "~/common/scss/variables";
@use "~/common/scss/mq";

.preferred-source {
  align-items: center;
  color: inherit;
  display: inline-flex;
  flex-shrink: 0;
  min-height: 44px;
  text-decoration: none;

  &__pill {
    align-items: center;
    background: rgb(0 0 0 / 60%);
    border: 1px solid rgb(255 255 255 / 65%);
    border-radius: 999px;
    box-sizing: border-box;
    display: inline-flex;
    font-family: inherit;
    font-size: helpers.px-to-rem(12);
    gap: helpers.px-to-rem(6);
    height: 26px;
    line-height: 1;
    padding: 0 helpers.px-to-rem(10);
    white-space: nowrap;
  }

  &__icon {
    height: 14px;
    width: 14px;
  }

  &__full {
    display: none;
  }

  &:hover &__pill {
    background: #fff;
    border-color: #fff;
    color: #111;
  }

  &:focus-visible {
    border-radius: 999px;
    outline: 2px solid currentColor;
    outline-offset: 3px;
  }

  .blog-stage--no-image &__pill {
    background: transparent;
    border-color: rgb(0 0 0 / 65%);
  }

  .blog-stage--no-image &:hover &__pill {
    background: #111;
    border-color: #111;
    color: #fff;
  }

  @include mq.mq(variables.$mq-2-min) {
    &__full {
      display: inline;
    }

    &__short {
      display: none;
    }
  }
}
</style>
